{
  "action_form": {
    "select_placeholder": "Select…"
  }
}
